import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 51,
	viewBox: "0 0 56 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_36523_10028)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M26.4617 9.1665C27.3598 7.61094 29.605 7.61095 30.5031 9.1665L46.8175 37.4238C47.7156 38.9794 46.593 40.9238 44.7968 40.9238H12.168C10.3718 40.9238 9.24922 38.9794 10.1473 37.4238L26.4617 9.1665Z",
				fill: "url(#paint0_linear_36523_10028)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ii_36523_10028)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.0736 15.7778C17.9717 14.2223 20.217 14.2223 21.1151 15.7778L36.6718 42.7228C37.5699 44.2784 36.4473 46.2228 34.6511 46.2228H3.53765C1.74145 46.2228 0.618826 44.2784 1.51693 42.7228L17.0736 15.7778Z",
				fill: "#F8CE98",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4151 33.2804C17.4151 33.9017 17.9188 34.4054 18.5401 34.4054C19.1614 34.4054 19.6651 33.9017 19.6651 33.2804L19.6651 25.062C19.6651 24.4407 19.1614 23.937 18.5401 23.937C17.9188 23.937 17.4151 24.4407 17.4151 25.062L17.4151 33.2804Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8501 37.7183C16.8501 38.6502 17.6069 39.4058 18.5388 39.4058C19.4708 39.4058 20.2276 38.6502 20.2276 37.7183C20.2276 36.7863 19.4708 36.0308 18.5388 36.0308C17.6069 36.0308 16.8501 36.7863 16.8501 37.7183Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_36523_10028",
				x: 1.8313,
				y: 0,
				width: 53.3022,
				height: 48.9238,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 4,
						result: "effect1_foregroundBlur_36523_10028"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ii_36523_10028",
				x: -12.7991,
				y: .611328,
				width: 63.7869,
				height: 59.6113,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_36523_10028"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_36523_10028",
						result: "effect2_innerShadow_36523_10028"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_36523_10028_clip_path",
				transform: "translate(12.7991 -0.611328)",
				children: /* @__PURE__ */ _jsx("path", { d: "M17.0736 15.7778C17.9717 14.2223 20.217 14.2223 21.1151 15.7778L36.6718 42.7228C37.5699 44.2784 36.4473 46.2228 34.6511 46.2228H3.53765C1.74145 46.2228 0.618826 44.2784 1.51693 42.7228L17.0736 15.7778Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_36523_10028",
				x1: 8.48852,
				y1: 13.1829,
				x2: 51.9873,
				y2: 52.6763,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BF7109" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E28912"
				})]
			})
		] })
	]
});
export default SvgAlertTriage;
